// src/pages/PricingFuitesDonneesPage.tsx
import React from "react";
import './style.scss';
import RegistrationHeader from "./components/RegistrationHeader";

import { ReactComponent as TopRightSVG } from 'assets/img/particules_top-right.svg';
import { ReactComponent as BottomLeftSVG } from 'assets/img/particules_bottom-left.svg';
import IDTrackerPricing from "../IDTrackerPricing";

const PricingFuitesDonneesPage = () => {

  return (
    <div className="registration-page">
      {/* Top right SVG background */}
      <div className="svg-background svg-background--top-right">
        <TopRightSVG />
      </div>

      {/* Bottom left SVG background */}
      <div className="svg-background svg-background--bottom-left">
        <BottomLeftSVG />
      </div>

      <RegistrationHeader />

      <div className="registration-container-very-large">
        <IDTrackerPricing isPage={false} hideOffreGratuite={true} isOuSide={true}/>
      </div>
    </div>
  );
};

export default PricingFuitesDonneesPage;